// @flow

import {eventChannel} from 'redux-saga'

const geoOptions = {
  enableHighAccuracy: true,
  maximumAge: 30000,
  timeout: 27000,
}

const getErrorCallBack = () => {}

export async function watchLocation(ms: number) {
  return eventChannel(send => {
    const interval = setInterval(() => {
      navigator.geolocation.getCurrentPosition((position) => {
        send(position)
      }, getErrorCallBack, geoOptions)
    }, ms)
    return () => {
      clearInterval(interval)
    }
  })
}
